import { useEffect, useState } from "react";
import {
  listPartnerSponsorshipPlacements,
  getPartnerSponsorshipPlacement,
} from "../../api/partnerPortalApi";

function PartnerSponsorshipPlacementsPage() {
  const [placements, setPlacements] = useState([]);
  const [selected, setSelected] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    listPartnerSponsorshipPlacements()
      .then((body) => {
        setPlacements(body.placements || []);
        setStatus("ready");
      })
      .catch(() => {
        setPlacements([]);
        setStatus("error");
      });
  }, []);

  const openDetail = async (placementId) => {
    const body = await getPartnerSponsorshipPlacement(placementId);
    setSelected(body.placement);
  };

  return (
    <div className="panel-card">
        <h2>Sponsorship placements</h2>
        <p className="muted">View scheduled and active placements tied to your partner account.</p>

        {status === "loading" ? <p className="muted">Loading…</p> : null}
        {status === "error" ? <p className="muted">Unable to load placements.</p> : null}

        {placements.length === 0 && status === "ready" ? (
          <p className="muted">No placements yet. Contact your Client View administrator.</p>
        ) : null}

        <ul className="cv-studio-list">
          {placements.map((p) => (
            <li key={p.id}>
              <button type="button" className="cv-button-link" onClick={() => openDetail(p.id)}>
                <strong>{p.placementName}</strong>
              </button>
              {" · "}
              <span className="status-badge">{p.status}</span>
              {" · "}
              {p.slotName || p.slotKey}
              {" · "}
              Impressions: {p.performance?.impressions ?? 0} · Clicks: {p.performance?.clicks ?? 0}
            </li>
          ))}
        </ul>

        {selected ? (
          <div className="panel-card cv-studio-mini-card">
            <h3>{selected.placementName}</h3>
            <p>
              Status: <span className="status-badge">{selected.status}</span>
            </p>
            {selected.campaignName ? <p>Campaign: {selected.campaignName}</p> : null}
            <p>
              Slot: {selected.slotName} ({selected.slotKey})
            </p>
            <p>
              Dates: {selected.startsAt || "—"} → {selected.endsAt || "open"}
            </p>
            {selected.targetUrl ? <p>Target: {selected.targetUrl}</p> : null}
            {selected.asset ? (
              <p>
                Asset: {selected.asset.title} ({selected.asset.status})
              </p>
            ) : null}
            <p>
              Performance — Impressions: {selected.performance?.impressions ?? 0}, Clicks:{" "}
              {selected.performance?.clicks ?? 0}, CTR:{" "}
              {((selected.performance?.ctr ?? 0) * 100).toFixed(1)}%
            </p>
          </div>
        ) : null}
    </div>
  );
}

export default PartnerSponsorshipPlacementsPage;
